import React from 'react';
import './button.css';

function Button({method, children}) {
    return (
        <div className="button-area" onClick={method}>
            {children}
        </div>
    );
}

export default Button;